<template>
  <BaseTable :name='name' :getDataAction='getDataAction' :tableColumns='tableColumns' :isShowCloseBtn='isShowCloseBtn' @SizeChange='sizeChange' @StateChange='stateChange'></BaseTable>
</template>


<script>
import {
  GetSupplierDistributionRatio
} from '@/api'
import BaseTable from './../baseTable.vue'

export default ({
  components: {
    BaseTable
  },
  data () {
    return {
      getDataAction: GetSupplierDistributionRatio,
      tableColumns: [
        {
          no: 'supplierName',
          name: '供应商',
          width: 120,
          type: 'text'
        },
        {
          no: 'ratio',
          name: '配送完成率',
          width: 100,
          type: 'text',
          formatter: this.ratioFormatter
        },

      ],
    };
  },
  props: {
    name: {
      type: String,
      default () {
        return ''
      }
    },
    isShowCloseBtn: {
      type: Boolean,
      default () {
        return true
      }
    }
  },
  //监听beforinfo值的变化
  watch: {
  },
  methods: {
    ratioFormatter (row) {
      return `${row.ratio}%`
    },

    sizeChange (a, b, c, d) {
      this.$emit('SizeChange', a, b, c, d)
    },
    stateChange (a, b) {
      this.$emit('StateChange', a, b)
    },
  },
  mounted () {
  },
  /** 生命周期 - 创建完成（可以访问当前this实例） */
  created () {
  },
  beforeDestroy () {
  },
})
</script>
<style scoped lang="scss">
</style>
